<template>
  <div id="app">
    <component v-if="errorComponent" :is="errorComponent" />
    <router-view v-else />
    <update-modal v-if="updateModal"></update-modal>
    <a href="https://wa.me/5581981812327" target="_blank" class="button button-icon button-success" style="position: fixed; bottom: 18px; right: 18px; display: flex; align-items: center; justify-content: center; width: 60px; height: 40px; border-radius: 50%;">
      <img src="@/assets/images/whatsapp_negative.png" style="display: inline-block; margin-right: 0;" />
    </a>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Error404 from '@/views/404'
import Error500 from '@/views/500'
import UpdateModal from '@/components/UpdateModal'

export default {
  name: 'app',
  components: {
    Error404,
    Error500,
    UpdateModal
  },
  data () {
    return {
      errorComponent: null
    }
  },
  computed: {
    ...mapGetters(['errorPage', 'updateModal'])
  },
  created () {
    if (this.$route.meta && this.$route.meta.error) this.errorComponent = '404'
  },
  watch: {
    'errorPage' (val) {
      this.errorComponent = val
    },
    '$route.meta.error' (val) {
      if (val) this.errorComponent = '404'
    }
  }
}
</script>
